import React, { useContext } from "react";
import SelectionItem from "../../SelectionItem";
import ImgCementImplantProsthesisFixation from "./images/cementImplantProsthesisFixation.png";
import ImgMultiunitImplantProsthesisFixationTop from "./images/multiunitImplantProsthesisFixationTop.png";
import ImgTelescopImplantProsthesisFixationTop from "./images/telescopImplantProsthesisFixationTop.png";
import ImgMultiunitImplantProsthesisFixationBottom from "./images/multiunitImplantProsthesisFixationBottom.png";
import ImgTelescopImplantProsthesisFixationBottom from "./images/telescopImplantProsthesisFixationBottom.png";
import ImgMultiunitImplantProsthesisFixationBoth from "./images/multiunitImplantProsthesisFixationBoth.png";
import ImgTelescopImplantProsthesisFixationBoth from "./images/telescopImplantProsthesisFixationBoth.png";
import "./index.scss";
import { cementImplantProsthesisFixationBoth4, cementImplantProsthesisFixationBoth6, cementImplantProsthesisFixationBottom4, cementImplantProsthesisFixationBottom6, cementImplantProsthesisFixationTop4, cementImplantProsthesisFixationTop6, multiunitImplantProsthesisFixationBoth4, multiunitImplantProsthesisFixationBoth6, multiunitImplantProsthesisFixationBottom4, multiunitImplantProsthesisFixationBottom6, multiunitImplantProsthesisFixationTop4, multiunitImplantProsthesisFixationTop6, telescopImplantProsthesisFixationBoth4, telescopImplantProsthesisFixationBoth6, telescopImplantProsthesisFixationBottom4, telescopImplantProsthesisFixationBottom6, telescopImplantProsthesisFixationTop4, telescopImplantProsthesisFixationTop6 } from "./implantFixationVariants";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const AdentyFullTypeImplantsFixation = ({
  selectStep,
  stepId
}) => {
  const {
    _t
  } = useTranslation();
  const {
    toggleBottomBarInfo
  } = useContext(StepContext);

  function getAvailableTypes(type) {
    let implantCounter = type.includes("Implant6") ? "6" : "4";

    switch (type) {
      case "PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant_adentyImplantProsthesisFixation_adentyTopImplant4":
      case "PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant_adentyImplantProsthesisFixation_adentyTopImplant6":
        return [{
          key: "cementImplantProsthesisFixationTop" + implantCounter,
          infoKey: "cementImplantProsthesisFixationTop",
          img: ImgCementImplantProsthesisFixation,
          name: _t("Цементная фиксация протеза к импланту"),
          description: _t("Применимо практически ко всем типам конструкций на имплантах....")
        }, {
          key: "multiunitImplantProsthesisFixationTop" + implantCounter,
          infoKey: "multiunitImplantProsthesisFixationTop",
          img: ImgMultiunitImplantProsthesisFixationTop,
          name: _t("Фиксация протеза на мульти-юнитах"),
          description: _t("Для сложных конструкций большей протяженности с непараллельной позицией имплантов....")
        }, {
          key: "telescopImplantProsthesisFixationTop" + implantCounter,
          infoKey: "telescopImplantProsthesisFixationTop",
          img: ImgTelescopImplantProsthesisFixationTop,
          name: _t("Фиксация протеза на телескопических коронках"),
          description: _t("Для сложных конструкций большей протяженности с непараллельной позицией имплантов....")
        }];

      case "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant_adentyImplantProsthesisFixation_adentyBottomImplant4":
      case "PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant_adentyImplantProsthesisFixation_adentyBottomImplant6":
        return [{
          key: "cementImplantProsthesisFixationBottom" + implantCounter,
          infoKey: "cementImplantProsthesisFixationBottom",
          img: ImgCementImplantProsthesisFixation,
          name: _t("Цементная фиксация протеза к импланту"),
          description: _t("Применимо практически ко всем типам конструкций на имплантах....")
        }, {
          key: "multiunitImplantProsthesisFixationBottom" + implantCounter,
          infoKey: "multiunitImplantProsthesisFixationBottom",
          img: ImgMultiunitImplantProsthesisFixationBottom,
          name: _t("Фиксация протеза на мульти-юнитах"),
          description: _t("Для сложных конструкций большей протяженности с непараллельной позицией имплантов....")
        }, {
          key: "telescopImplantProsthesisFixationBottom" + implantCounter,
          infoKey: "telescopImplantProsthesisFixationBottom",
          img: ImgTelescopImplantProsthesisFixationBottom,
          name: _t("Фиксация протеза на телескопических коронках"),
          description: _t("Для сложных конструкций большей протяженности с непараллельной позицией имплантов....")
        }];

      case "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant_adentyImplantProsthesisFixation_adentyBothImplant4":
      case "PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant_adentyImplantProsthesisFixation_adentyBothImplant6":
        return [{
          key: "cementImplantProsthesisFixationBoth" + implantCounter,
          infoKey: "cementImplantProsthesisFixationBoth",
          img: ImgCementImplantProsthesisFixation,
          name: _t("Цементная фиксация протеза к импланту"),
          description: _t("Применимо практически ко всем типам конструкций на имплантах....")
        }, {
          key: "multiunitImplantProsthesisFixationBoth" + implantCounter,
          infoKey: "multiunitImplantProsthesisFixationBoth",
          img: ImgMultiunitImplantProsthesisFixationBoth,
          name: _t("Фиксация протеза на мульти-юнитах"),
          description: _t("Для сложных конструкций большей протяженности с непараллельной позицией имплантов....")
        }, {
          key: "telescopImplantProsthesisFixationBoth" + implantCounter,
          infoKey: "telescopImplantProsthesisFixationBoth",
          img: ImgTelescopImplantProsthesisFixationBoth,
          name: _t("Фиксация протеза на телескопических коронках"),
          description: _t("Для сложных конструкций большей протяженности с непараллельной позицией имплантов....")
        }];

      default:
        return [];
    }
  }

  const types = getAvailableTypes(stepId);

  function setStep(key) {
    let updatedData = {};

    switch (key) {
      case "cementImplantProsthesisFixationTop4":
        updatedData = cementImplantProsthesisFixationTop4;
        break;

      case "cementImplantProsthesisFixationTop6":
        updatedData = cementImplantProsthesisFixationTop6;
        break;

      case "cementImplantProsthesisFixationBottom4":
        updatedData = cementImplantProsthesisFixationBottom4;
        break;

      case "cementImplantProsthesisFixationBottom6":
        updatedData = cementImplantProsthesisFixationBottom6;
        break;

      case "cementImplantProsthesisFixationBoth4":
        updatedData = cementImplantProsthesisFixationBoth4;
        break;

      case "cementImplantProsthesisFixationBoth6":
        updatedData = cementImplantProsthesisFixationBoth6;
        break;

      case "multiunitImplantProsthesisFixationTop4":
        updatedData = multiunitImplantProsthesisFixationTop4;
        break;

      case "multiunitImplantProsthesisFixationTop6":
        updatedData = multiunitImplantProsthesisFixationTop6;
        break;

      case "multiunitImplantProsthesisFixationBottom4":
        updatedData = multiunitImplantProsthesisFixationBottom4;
        break;

      case "multiunitImplantProsthesisFixationBottom6":
        updatedData = multiunitImplantProsthesisFixationBottom6;
        break;

      case "multiunitImplantProsthesisFixationBoth4":
        updatedData = multiunitImplantProsthesisFixationBoth4;
        break;

      case "multiunitImplantProsthesisFixationBoth6":
        updatedData = multiunitImplantProsthesisFixationBoth6;
        break;

      case "telescopImplantProsthesisFixationTop4":
        updatedData = telescopImplantProsthesisFixationTop4;
        break;

      case "telescopImplantProsthesisFixationTop6":
        updatedData = telescopImplantProsthesisFixationTop6;
        break;

      case "telescopImplantProsthesisFixationBottom4":
        updatedData = telescopImplantProsthesisFixationBottom4;
        break;

      case "telescopImplantProsthesisFixationBottom6":
        updatedData = telescopImplantProsthesisFixationBottom6;
        break;

      case "telescopImplantProsthesisFixationBoth4":
        updatedData = telescopImplantProsthesisFixationBoth4;
        break;

      case "telescopImplantProsthesisFixationBoth6":
        updatedData = telescopImplantProsthesisFixationBoth6;
        break;

      default:
        break;
    }

    selectStep(key, updatedData);
  }

  function openBottomBar(type) {
    toggleBottomBarInfo(true, type);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "adentyFullTypeImplantsFixation"
  }, /*#__PURE__*/React.createElement("div", {
    className: "adentyFullTypeImplantsFixation-list"
  }, types.map(el => /*#__PURE__*/React.createElement(SelectionItem, {
    key: el.key,
    itemKey: el.key,
    isSelected: false,
    select: () => {
      setStep(el.key);
    },
    preview: el.img,
    innerTitle: el.name,
    outerDescription: el.description,
    aboutClick: () => openBottomBar(el.infoKey)
  }))));
};

export default AdentyFullTypeImplantsFixation;